import React, { memo } from 'react';
import {
	Route,
	Switch,
	useRouteMatch
} from 'react-router-dom';

import { log } from '../../../../services/utils';

import { useAuthState } from '../../../../contexts/AuthContext';
import { Provider as AgenciesProvider } from '../../../../contexts/AgenciesContext';
import { Provider as SubmissionsProvider } from '../../../../contexts/SubmissionsContext';

import AgencyList from './AgencyList';
import AgencyDetails from './AgencyDetails';

const Directory = () => {
	const { path } = useRouteMatch();

	const { user: { permissions } } = useAuthState();

	return (
		<AgenciesProvider>
			<SubmissionsProvider>
				{ log( 'agencies' ) }
				<Switch>
					{ permissions.addAgencies.isAvailable && permissions.addAgencies.canExecute
						|| permissions.viewAgencies.isAvailable && permissions.viewAgencies.canExecute
						|| permissions.editAgencies.isAvailable && permissions.editAgencies.canExecute
						? <Route
							path={ `${ path }/:id` }
							component={ AgencyDetails }
						/>
						: null
					}
					<Route
						exact
						path={ path }
						component={ AgencyList }
					/>
				</Switch>
			</SubmissionsProvider>
		</AgenciesProvider>
	);
};

export default memo( Directory );
